import { useContext, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import secondaryComponents from "../../../../../components/secondaryComponents";
import primaryComponents from "../../../../../components/primaryComponents";
import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import { useAuthorizeLumiOnSquareup } from "../../../../../hooks/api/mutations/useSquareup";
import { useGetSquareAuthStatus } from "../../../../../hooks/api/queries/useSquareup";
import { pathConstants } from "../../../../../routes/pathContants";
import { useOAuthPopup } from "../../../../../hooks/useOAuthPopup";
import { useQueryClient } from "react-query";
import { ToastContext } from "../../../../../hooks/context";

const SquareupAuth = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [search] = useSearchParams();
  const triggerToast = useContext(ToastContext);
  const { openPopup } = useOAuthPopup({
    onSuccess: () => {
      queryClient.invalidateQueries(["getSquareAuthStatus"]);
    },
  });

  const { data: squareValidity, isLoading: isLoadingStatus } =
    useGetSquareAuthStatus();

  const { mutate: authorizeLumiOnSquareup, isLoading } =
    useAuthorizeLumiOnSquareup();

  const handleAuthorize = () => {
    // openPopup(`${window.origin}${pathConstants.APPS_SQUAREUP_AUTH_CALLBACK}`);
    authorizeLumiOnSquareup(
      {},
      {
        onSuccess: (res) => {
          const authUrl = res?.data?.data?.auth_url;

          if (authUrl) openPopup(authUrl);
        },
      },
    );
  };

  useEffect(() => {
    if (squareValidity?.is_active) {
      navigate(pathConstants.APPS_SQUAREUP_CONNECTED_STORE);
    }
  }, [squareValidity, navigate]);

  useEffect(() => {
    if (search.get("status") === "error")
      triggerToast("Squareup authorization failed");
  }, [search.get("status")]);

  return (
    <secondaryComponents.MetaSetter
      title="Lumi Merchant | App - Squareup Connections"
      description="Connect & manage Squareup with Lumi Business"
    >
      <secondaryComponents.RequestLoaderTrigger>
        <div className={globalStyles.pageColumnGaps}>
          <div>
            <h4 className="mb-0">Manage Squareup App</h4>
            <p>Connect & manage Squareup with Lumi Business</p>
          </div>

          <secondaryComponents.LoaderHelper
            isLoading={isLoadingStatus}
            classNames="mt-5"
          >
            <div
              className={`${globalStyles.cardWithBackground} white mt-5 mx-auto`}
              style={{ maxWidth: 500 }}
            >
              <primaryComponents.Button
                classNames="btn btn--primary"
                isDisabled={isLoading}
                isLoading={isLoading}
                loadingText="Processing..."
                onClick={handleAuthorize}
              >
                Connect Lumi to Squareup
              </primaryComponents.Button>
            </div>
          </secondaryComponents.LoaderHelper>
        </div>
      </secondaryComponents.RequestLoaderTrigger>
    </secondaryComponents.MetaSetter>
  );
};

export default SquareupAuth;
